import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "800",
  height: "800",
  fill: "none",
  stroke: "#fff",
  "stroke-width": "4",
  viewBox: "0 0 64 64"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  d: "m9.57 15.41 2.6 8.64 8.64-2.61M26.93 41.41V23a.09.09 0 0 0-.16-.07s-2.58 3.69-4.17 4.78"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("rect", {
  width: "11.41",
  height: "18.89",
  x: "32.19",
  y: "22.52",
  rx: "5.7"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  d: "M12.14 23.94a21.91 21.91 0 1 1-.91 13.25"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }